// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__jqVx9","select":"Header_select__1J0Ey","clinic":"Header_clinic__I1CGM"};